import template   from './registration-confirmation.html'
import controller from './registration-confirmation.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration-confirmation/registration-confirmation.component.js